import { ShoppingBasket } from 'components/icons'
import { Button } from 'components/ui'
import type { FC } from 'react'
import type { CartButtonProps } from '.'
import s from './cart-button.module.css'

const CartButton: FC<CartButtonProps> = ({ total, ...rest }) => {
  return (
    <Button className={s.root} variant="ghost" {...rest}>
      <ShoppingBasket />
      <span className={s.quantity}>{total}</span>
    </Button>
  )
}

export default CartButton
